/* House of Bones 2026 · header: free shipping bars + keep the menu on one row */
(function () {
  var cfg = window.HOB || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EUROPE = 'AT BG HR CY CZ DK EE FI GR HU IE IT LV LT MT PL PT RO SK SI ES SE CH NO IS LI MC AD SM VA'.split(' ');

  function rate() { return parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1; }
  function currency() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.shopCurrency || 'EUR'; }
  function money(c) {
    var cur = currency();
    if (cur === 'EUR') return '€' + (c / 100).toFixed(2).replace('.', ',');
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* Free shipping threshold for the visitor's country, in cents of the active currency (0 = no bar) */
  function threshold() {
    var map = {};
    (cfg.shipRates || []).forEach(function (line) {
      var p = String(line).trim().split(/[\s:=]+/);
      if (p.length >= 2) { var v = parseFloat(p[1].replace(',', '.')); if (!isNaN(v)) map[p[0].toUpperCase()] = v; }
    });
    if (!Object.keys(map).length && cfg.freeShipping) map.BE = map.NL = parseFloat(String(cfg.freeShipping).replace(',', '.'));
    var c = String(cfg.country || (window.Shopify && Shopify.country) || 'BE').toUpperCase();
    var eur = map[c] != null ? map[c] : (EUROPE.indexOf(c) > -1 ? map.EUROPE : null);
    if (eur == null || isNaN(eur)) return 0;
    return Math.round(eur * rate() * 100);
  }
  var free = threshold();

  /* Where the shopper stands; null = show nothing (empty cart or no free shipping to their country) */
  function state(cart) {
    if (!free || !cart || !cart.item_count) return null;
    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var left = Math.max(0, free - sub);
    return {
      left: left,
      pct: Math.min(100, Math.round((sub / free) * 100)),
      text: left > 0 ? (cfg.tShipLeft || 'You are {amount} away from free shipping').replace('{amount}', money(left)) : (cfg.tShipDone || 'Free shipping unlocked')
    };
  }
  function fill(el, st) {
    el.querySelector('[data-text]').textContent = st.text;
    var bar = el.querySelector('[role="progressbar"]');
    bar.setAttribute('aria-valuenow', st.pct);
    bar.firstChild.style.width = st.pct + '%';
    el.classList.toggle('is-done', st.left === 0);
  }
  var BAR = '<span class="hob-cbar__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span></span></span>';

  /* 1. Strip under the header, on every page */
  var wrap = document.querySelector('.header-wrapper');
  var strip = null;
  if (wrap && free && !document.querySelector('[data-hob-shipstrip]')) {
    strip = document.createElement('div');
    strip.className = 'hob-shipstrip';
    strip.setAttribute('data-hob-shipstrip', '');
    strip.hidden = true;
    strip.innerHTML = '<div class="page-width hob-shipstrip__in"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg><span class="hob-shipstrip__text" data-text aria-live="polite"></span><span class="hob-shipstrip__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span></span></span></div>';
    wrap.appendChild(strip);
  }

  /* 2. Same bar inside the cart drawer and on the cart page, plus a few extras when close */
  function cartBar(host, before, st) {
    var el = host.querySelector('.hob-cbar');
    if (!st) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'hob-cbar';
      el.innerHTML = '<p class="hob-cbar__text" data-text aria-live="polite"></p>' + BAR;
      if (before && before.parentNode) before.parentNode.insertBefore(el, before.nextSibling); else host.prepend(el);
    }
    fill(el, st);
  }

  var extras = null, extrasBusy = false;
  function loadExtras(cb) {
    if (extras) return cb(extras);
    if (!cfg.extrasUrl || extrasBusy) return;
    extrasBusy = true;
    fetch(cfg.extrasUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { extras = (d && d.products) || []; extrasBusy = false; cb(extras); })
      .catch(function () { extrasBusy = false; });
  }
  function drawExtras(host, cart, st) {
    var box = host.querySelector('.hob-cx');
    var within = Math.round((parseFloat(cfg.extrasWithin) || 30) * rate() * 100);
    if (!st || st.left <= 0 || st.left > within) { if (box) box.remove(); return; }
    loadExtras(function (list) {
      var inCart = {};
      (cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; });
      var eur = currency() === 'EUR';
      var picks = list.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v || inCart[p.id]) return null;
        var cents = Math.round(parseFloat(v.price) * 100);
        return { p: p, v: v, cents: cents, single: p.variants.length === 1, score: cents >= st.left ? cents - st.left : 100000 + (st.left - cents) };
      }).filter(Boolean).sort(function (a, b) { return a.score - b.score; }).slice(0, 3);
      var items = host.querySelector('cart-drawer-items') || host;
      box = host.querySelector('.hob-cx');
      if (!picks.length) { if (box) box.remove(); return; }
      var html = '<p class="hob-cx__head">' + esc(cfg.tExtras || 'Add a little extra') + '</p><ul class="hob-cx__list" role="list">';
      picks.forEach(function (x) {
        var url = root + 'products/' + x.p.handle;
        var img = x.p.images && x.p.images[0] ? x.p.images[0].src : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        html += '<li class="hob-cx__item"><a class="hob-cx__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</a>' +
          '<span class="hob-cx__info"><a href="' + url + '">' + esc(x.p.title) + '</a>' + (eur ? '<span>' + money(x.cents) + '</span>' : '') + '</span>' +
          (x.single ? '<button type="button" class="hob-cx__add" data-hob-extra="' + x.v.id + '">' + esc(cfg.tAdd || 'Add') + '</button>' : '<a class="hob-cx__add" href="' + url + '">' + esc(cfg.tChoose || 'Choose') + '</a>') + '</li>';
      });
      html += '</ul>';
      if (!box) { box = document.createElement('div'); box.className = 'hob-cx'; items.appendChild(box); }
      box.innerHTML = html;
    });
  }

  var lastCart = null;
  function paint(cart) {
    if (!cart) return;
    lastCart = cart;
    var st = state(cart);
    if (strip) { if (st) { fill(strip, st); strip.hidden = false; } else strip.hidden = true; }
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) { cartBar(inner, inner.querySelector('.drawer__header'), st); drawExtras(inner, cart, st); }
    var page = document.querySelector('cart-items:not(cart-drawer-items) .title-wrapper-with-link');
    if (page) cartBar(page.parentNode, page, st);
  }
  function refresh() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {});
  }
  if (free) {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); });
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    /* The theme redraws the cart drawer after every change: put the bar back */
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var t = 0;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var inner = drawer.querySelector('.drawer__inner');
          if (inner && !inner.querySelector('.hob-cbar') && !drawer.classList.contains('is-empty')) refresh();
        }, 120);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  /* Add an extra from the cart drawer */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hob-extra]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-hob-extra'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { b.disabled = false; return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hob-extras' });
        else refresh();
      })
      .catch(function () { b.disabled = false; });
  });

  /* Keep the desktop menu on one row: shrink text and spacing until it fits */
  var nav = document.querySelector('.header__inline-menu');
  var list = nav && nav.querySelector('.list-menu--inline');
  var steps = [[1.5, 1.2, .08], [1.45, 1.0, .07], [1.4, .9, .06], [1.35, .8, .05], [1.3, .7, .05], [1.25, .6, .04], [1.2, .5, .03], [1.15, .45, .02], [1.1, .4, .01]];
  function fit() {
    if (!list || getComputedStyle(nav).display === 'none') return;
    for (var i = 0; i < steps.length; i++) {
      nav.style.setProperty('--hob-menu-fs', steps[i][0] + 'rem');
      nav.style.setProperty('--hob-menu-px', steps[i][1] + 'rem');
      nav.style.setProperty('--hob-menu-ls', steps[i][2] + 'em');
      if (list.scrollWidth <= nav.clientWidth + 1) break;
    }
  }
  if (list) {
    fit();
    var raf = 0;
    window.addEventListener('resize', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('load', fit);
  }
})();

/* Mobile: the small top links (Gift Cards, Events, News) at the bottom of the menu drawer */
(function () {
  var top = document.querySelector('[data-hob-toplinks]');
  var util = document.querySelector('.menu-drawer__utility-links');
  if (!top || !util || util.querySelector('.hob-drawer-links')) return;
  var ul = document.createElement('ul');
  ul.className = 'hob-drawer-links list-unstyled';
  ul.setAttribute('role', 'list');
  top.querySelectorAll('a').forEach(function (a) {
    var li = document.createElement('li');
    var c = a.cloneNode(true);
    c.className = 'hob-drawer-links__a';
    li.appendChild(c);
    ul.appendChild(li);
  });
  util.insertBefore(ul, util.firstChild);
})();

/* "Ask us" links (data-hob-chat): open the Shopify Inbox chat bubble, else follow the link to the contact page */
(function () {
  function chatButton() {
    var hosts = document.querySelectorAll('inbox-online-store-chat, #ShopifyChat, shopify-chat, [id^="shopify-chat"]');
    for (var i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot || hosts[i];
      var btn = root.querySelector('button.chat-toggle, button[class*="toggle"], button[aria-label*="hat"], button');
      if (btn) return btn;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-hob-chat]');
    if (!link) return;
    var btn = chatButton();
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });
})();

/* Dark mode: product photos saved as PNG (often without background) get a white panel */
(function () {
  function mark() {
    document.querySelectorAll('.media img, .hob-lp__tile-img img, .thumbnail img, img.cart-item__image').forEach(function (img) {
      var s = (img.getAttribute('src') || '') + ' ' + (img.getAttribute('srcset') || '');
      if (/\.png(\?|\s|$)/i.test(s)) {
        var m = img.closest('.thumbnail, .media, .hob-lp__tile-img, .cart-item__image');
        if (m && !m.classList.contains('hob-png')) m.classList.add('hob-png');
      }
    });
  }
  mark();
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(mark, 150); }).observe(document.body, { childList: true, subtree: true });
})();
